import PropTypes from "prop-types";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ToggleButton from "./ToggleButton";

import { segmentProps } from "./audienceProps";
import { styles } from "./audienceStyles";

export default class DiscreteAudienceSegmentSelector extends React.PureComponent {
    static propTypes = {
        isReadOnly: PropTypes.bool.isRequired,
        segments: PropTypes.arrayOf(PropTypes.shape(segmentProps)).isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(changedSegment) {
        if (this.props.isReadOnly) {
            return;
        }

        const selectedSegments = this.props.segments.filter(
            segment =>
                segment === changedSegment
                    ? !segment.isSelected
                    : segment.isSelected
        );
        this.props.onChange(selectedSegments);
    }

    renderToggleButtonForSegment(segment, isOnlySelectedSegment) {
        const label = segment.isSelected ? (
            <span>
                <FontAwesomeIcon icon="check" /> {segment.label}
            </span>
        ) : (
            segment.label
        );
        return (
            <ToggleButton
                key={segment.id}
                value={segment.id}
                disabled={this.props.isReadOnly || isOnlySelectedSegment}
                label={label}
                isSelected={segment.isSelected}
                onChange={() => this.onChange(segment)}
            />
        );
    }

    render() {
        const onlyOneSegmentSelected =
            this.props.segments.filter(segment => segment.isSelected).length ===
            1;
        const segments = this.props.segments.map(segment =>
            this.renderToggleButtonForSegment(
                segment,
                segment.isSelected && onlyOneSegmentSelected
            )
        );
        return <div className={styles.segmentSelection}>{segments}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/DiscreteAudienceSegmentSelector.js